module.exports = __webpack_public_path__ + "img/chair_rendered_thumb.39387641.jpg";